export const container = "bg-white w-full flex justify-between items-center p-2 border-green-300 border-b border-solid"
export const content = "flex items-center ml-auto gap-5 pl-6 pr-6";
export const dropdownContainer = "absolute top-full right-0 z-10 bg-white border border-gray-200 shadow-md hidden";
